// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__A_0WM","questions":"styles_questions__MHXkh","footer":"styles_footer__3Z8IK"};